import React, { useEffect, FC } from "react";
import { Link, useLocation } from "react-router-dom";
import { Icon } from "../../components/Component"; // Assuming these are properly typed elsewhere
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";

interface PurchaseRequestAsideProps {
  updateSm: (value: boolean) => void; // Function to update state
  sm: boolean; // Boolean state
}

const RateContractAside: FC<PurchaseRequestAsideProps> = ({ updateSm, sm }) => {
  const { data: allowedRoutes }: any = useSelector(
    (state: RootState) => state.allowedRoutes
  );
  const location = useLocation();

  useEffect(() => {
    sm
      ? document.body.classList.add("toggle-shown")
      : document.body.classList.remove("toggle-shown");
  }, [sm]);

  const isActive = (path: string): string => {
    return location.pathname === path ? "active" : "";
  };

  const LinkTo = ({ path }: any) => {
    if (!allowedRoutes.includes(path)) {
      return null;
    }
    switch (path) {
      case "view-rate-contract":
        return (
          <Link
            to="/view-rate-contract"
            className={isActive(`${process.env.PUBLIC_URL}/view-rate-contract`)}
          >
            <Icon name="eye-fill" />
            <span>View</span>
          </Link>
        );
      case "rate-contract-new":
        return (
          <Link
            to="/rate-contract-new"
            className={isActive(`${process.env.PUBLIC_URL}/rate-contract-new`)}
          >
            <Icon name="plus-fill-c" />
            <span>Add New</span>
          </Link>
        );
      case "approvals-rate-contract":
        return (
          <Link
            to="/approvals-rate-contract"
            className={isActive(
              `${process.env.PUBLIC_URL}/approvals-rate-contract`
            )}
          >
            <Icon name="check-fill-c" />
            <span>Pending Approvals</span>
          </Link>
        );
      // case "track-rate-contract":
      //   return (
      //     <Link
      //       to="/track-rate-contract"
      //       className={isActive(
      //         `${process.env.PUBLIC_URL}/track-rate-contract`
      //       )}
      //     >
      //       <Icon name="eye-fill" />
      //       <span>Track</span>
      //     </Link>
      //   );
      // case "analytics-rate-contract":
      //   return (
      //     <Link
      //       to="/analytics-rate-contract"
      //       className={isActive(
      //         `${process.env.PUBLIC_URL}/analytics-rate-contract`
      //       )}
      //     >
      //       <Icon name="growth-fill" />
      //       <span>Analytics</span>
      //     </Link>
      //   );
      default:
        return null;
    }
  };

  return (
    <div className="card-inner-group">
      <div className="card-inner">
        <div className="user-account-info py-0">
          <h6 className="overline-title-alt" style={{ fontSize: 14 }}>
            Rate Contract
          </h6>
        </div>
      </div>
      <div className="card-inner p-0">
        <ul className="link-list-menu">
          {[
            "view-rate-contract",
            "rate-contract-new",
            "approvals-rate-contract",
          ].map((item) => (
            <li key={item} onClick={() => updateSm(false)}>
              <LinkTo path={item} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default RateContractAside;
